"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = filterUniversalIssues;
const accessibility_standards_1 = __importDefault(require("@deque/accessibility-standards"));
const filter_extension_issues_1 = require("./filter-extension-issues");
function filterUniversalIssues(issues, filters) {
    const filteredIssues = [];
    const totalIssues = [];
    issues.forEach(issue => {
        const isIssueBestPractice = (0, filter_extension_issues_1.isBestPracticeIssue)({ tags: issue.tags, rule: issue.ruleId }, { accessibilityStandard: filters.configAccessibilityStandard });
        // Base Filters
        // Do not include best practice issue if best practices are disabled
        if (filters.configBestPractices === 'disabled' && isIssueBestPractice) {
            return;
        }
        // Do not include needs review issue if needs review is disabled
        if (filters.configNeedsReview === 'disabled' && issue.needsReview) {
            return;
        }
        // If a manifest is selected, only include issues from the selected manifest
        if (filters.manifestId && issue.manifestId !== filters.manifestId) {
            return;
        }
        const issueMatchesRuleset = issue.tags?.find(tag => accessibility_standards_1.default[filters.configAccessibilityStandard].tags.includes(tag));
        // If Trusted Tester v5 (TTv5) is selected and the issue is manual, do not exclude it on the basis of not matching the ruleset.
        // This is due to the fact that Dequeway does not include TTv5 in any IGT tags, so it will never match the ruleset.
        const isTrustedTesterWithIGT = filters.configAccessibilityStandard === 'TTv5' && issue.isManual;
        // If not a best practice issue AND the issue's tags don't include the applied standard/ruleset AND the issue is not TTv5 + an IGT, exclude the issue
        if (!isIssueBestPractice &&
            !issueMatchesRuleset &&
            !isTrustedTesterWithIGT) {
            return;
        }
        // If page state key filter is provided, we need to include issues only related to this page state
        if (filters.pageStateKey && issue.pageStateKey !== filters.pageStateKey) {
            return;
        }
        if (filters.newIssues && !issue.isNewIssue) {
            return;
        }
        // Other Filters
        const addIssue = () => {
            // Do not included needs review in total issues if they are exclude
            if (filters.configNeedsReview !== 'exclude' || !issue.needsReview) {
                totalIssues.push(issue);
            }
            filteredIssues.push(issue);
        };
        if (filters.automatic && !issue.isManual && !issue.isAdvanced) {
            addIssue();
            return;
        }
        if (filters.advanced && !issue.isManual && issue.isAdvanced) {
            if (filters.configNeedsReview === 'exclude' && issue.needsReview) {
                return;
            }
            addIssue();
            return;
        }
        if (filters.manual && issue.isManual && !issue.igtId) {
            addIssue();
            return;
        }
        if (!filters.manifestId &&
            issue.igtId &&
            (filters.igt === 'all' || issue.igtId === filters.igt)) {
            addIssue();
            return;
        }
        if (filters.impact.includes(issue.impact) &&
            !issue.needsReview) {
            addIssue();
            return;
        }
        if (filters.bestPractices && isIssueBestPractice) {
            addIssue();
            return;
        }
        if (filters.needsReview && issue.needsReview) {
            addIssue();
            return;
        }
    });
    return { totalIssues, filteredIssues };
}
//# sourceMappingURL=filter-universal-issues.js.map